const extractURL = (text) => {
  const reg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g;
  return text.match(reg);
};

/**
 * 仅做 HTML 实体反转义，不做安全清洗。
 * 富文本编辑器等场景需要完整原始 HTML，不能在这里 sanitize。
 */
const unescapeHtml = (html) =>
  String(html)
    .replace(/&quot;/g, '"')
    // eslint-disable-next-line
    .replace(/&#39;/g, "'")
    .replace(/&#x3A;/g, ':')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    // eslint-disable-next-line
    .replace(/&#x27;/g, "'")
    .replace(/&amp;/g, '&');

const unescapeTextContentForBrowser = (text) => {
  if (typeof text === 'boolean' || typeof text === 'number') {
    return `${text}`;
  }
  return unescapeHtml(text);
};

const unescapeTextContent = (content) => unescapeTextContentForBrowser(content);

/**
 * 反馈 message / 对话用户内容展示用纯文本：
 * 只做实体反转义，不转 HTML。渲染时用 React 文本节点即可防 XSS。
 */
const toDisplayPlainText = (content: unknown): string => {
  if (content === null || content === undefined) {
    return '';
  }
  return String(unescapeTextContent(content));
};

/**
 * 展示用换行归一：把 <br> / CRLF / CR 收成 \n。
 * 仍是纯文本，不产出 HTML；渲染时按行拆成 React 文本节点即可防 XSS。
 */
const normalizeDisplayLineBreaks = (text: string): string =>
  text.replace(/<br\s*\/?>/gi, '\n').replace(/\r\n|\r/g, '\n');

const convertToString = (value: any) => {
  if (typeof value === 'object') {
    return JSON.stringify(value);
  }
  return String(value);
};

// 对象驼峰转下划线
const objectHumpToLine = (obj) => {
  const newObj = {};
  // eslint-disable-next-line no-restricted-syntax
  for (const key in obj) {
    newObj[
      key
        .replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)
        .replace(/^_/, '')
    ] = obj[key];
  }
  return newObj;
};

export {
  convertToString,
  extractURL,
  normalizeDisplayLineBreaks,
  objectHumpToLine,
  toDisplayPlainText,
  unescapeTextContent,
};
